import {Component, OnInit, HostListener} from "@angular/core";
import {CommonHelper} from "../../../shared/helpers/CommonHelper";
import {Json2csvService} from "../../../services/json2csv.service";
import {UrlBuilderFactory} from "../../../shared/factories/url-builder.factory";
import * as _ from 'lodash';
import {CostProjectService} from "../../../services/cost-project.service";
import * as moment from "moment";
import { DropdownSettingsFactory } from "../../../shared/factories/dropdown/dropdown-settings.factory";
import { DropdownItemFactory } from "../../../shared/factories/dropdown/dropdown-item.factory";
import { ToastsManager } from "ng2-toastr";
import { CostFiltersFactory } from "../../../shared/factories/cost/filters.factory";
import { LocalStorage } from "../../../shared/wrappers/LocalStorage";
import { ProjectFinancialService } from '../../../services/projectFinancial.service';
import { SubDivision } from "../../../models/SubDivision.model";
import { GUARDS } from "../../../shared/auth/Roles";

@Component({
    selector: "app-cost-by-project",
    templateUrl: "./cost-by-project-report.component.html",
    styleUrls: ["./cost-by-project-report.component.css"]
})
export class CostByProjectReportComponent implements OnInit {
    cost = [];
    allSubDivisions: any = [];
    subDivisions: SubDivision[] = new Array<SubDivision>();
    commonHelper: CommonHelper = new CommonHelper();
    itemsPerPage: number[] = [5, 10, 50, 100];
    totalItems: number = 0;
    currentPage: number = 1;
    dre:any = [];
    listDRE : boolean = false;
    output:string = '';
    datePattern = /^(0[1-9]|1[0-9]|2[0-9]|3[01]).(0[1-9]|1[012]).[0-9]{4}$/i;
    mask = [/[0-3]/,/[0-9]/,'/',/[0-1]/,/[0-9]/,'/',/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/];
    user;

    filters = {
        status: {list: [], options: null, selected: []},
        divisions: {list: [], options: null, selected: []},
        subDivision: {list: [], options: null, selected: []},
        companyGroups: {list: [], options: null, selected: []},
        owners: {list: [], options: null, selected: []},
        clients: { list: [], options:null, selected: []},
        consultant: {list: [], options:null, selected: []},
        responsible: {list: [], options:null, selected:[]},
        industries: {list: [], options:null, selected:[]},
        excellenceCenters: {list: [], options:null, selected:[]},
        supportCenter: {list: [], options:null, selected:[]},
        projects: {list: [], options:null, selected:[]},
        issued: {list: [{name: "Não Emitido", value: false}, {name: "Emitido", value: true}], selected: null},
        name: null,
        limit: {list: [5, 10, 50, 100], selected: 10},
        startDate: null,
        endDate: null,
        skip: 0
    };
    loading: boolean;


    constructor(private json2csvService: Json2csvService,
                private costService: CostProjectService,
                private costFiltersFactory: CostFiltersFactory,
                private queryStringFactory: UrlBuilderFactory,
                private projectFinancialService: ProjectFinancialService,
                private dropdownItemFactory: DropdownItemFactory,
                private localStorage: LocalStorage,
                private toastr: ToastsManager) {
    }

    async ngOnInit() {
        this.loading = true;
        this.user = this.localStorage.retrieve('user')
        let response = await this.projectFinancialService.getProjectsAndCustomers();
        let clients = response.customers;
        let projects = response.projects;
        this.filters = await this.costFiltersFactory.build(this.filters);
        this.filters.clients.list = this.dropdownItemFactory.build({source:clients});
        this.filters.projects.list = this.dropdownItemFactory.build({source:projects});
        await this.loadAllSubDivisions();
        this.onDivisionChange();
        await this.search(1);
        this.loading = false;
    }

    @HostListener('window:keyup', ['$event'])
    keyEvent(event: KeyboardEvent) {

        if (event.keyCode === 13) {
            this.search(1);
        }

    }
    async loadAllSubDivisions(){
        this.allSubDivisions = await this.projectFinancialService.getAllSubDivisions();
    }

   async onDivisionChange(){
    this.filters.subDivision.selected = [];
    this.filters.subDivision.list = [];

    if(this.filters.divisions.selected.length > 0){

      this.filters.divisions.selected.forEach(divisionSelected => {
          let subDivisions = this.allSubDivisions.find((subdivision: any) => subdivision.division == divisionSelected.id);
          if(subDivisions){
              this.filters.subDivision.list = [
                ...this.filters.subDivision.list,
                ...subDivisions.subDivision.map((item: any) => {
                  return {
                    id: item.code,
                    itemName: item.name,
                    'division': this.commonHelper.transcriptDivisionGroup(subDivisions.division)
                  }
                })
              ]
          }
      })
    }
  }

    async search(page, toexport?) {
        this.loading = true;
        let response
        if (toexport)
            response = await this.costService.getAll(this.queryStringFactory.build(this.loadFilters(page, toexport)));
        else
            response = await this.costService.getAll(this.queryStringFactory.build(this.loadFilters(page)));

        if (response.count[0]){
            this.totalItems = response.count[0].totalItems;
        }

        this.cost = response.cost;
        this.dre = response.dre
        this.generateIndex();
        this.loading = false;
    }

    generateIndex(){
        let index = 0;
        this.cost.map(item => {
            index++;
            item.index = index;
        });
    }

    loadFilters(page?, toexport?) {
        this.currentPage = page ? page : (this.currentPage ? this.currentPage : 1);

        let filters = {skip:0};

        _.forOwn(this.filters, (value, key) => {
            const selected = _.get(value, 'selected', value);
            if (selected == 'undefined' || selected == null) return;

            filters[key] = selected;
            filters[key] = _.isArray(filters[key]) ? filters[key].map(item => _.get(item, 'id')) : filters[key];
        });
        filters.skip = (this.currentPage - 1) * this.filters.limit.selected;
        if (toexport){
            delete filters.skip;
        }

        return filters;
    }

    async export() {
        this.loading = true;

        await this.search(1, true);
        if(this.listDRE){
            let totalCost = _.sumBy(this.dre,(item) => item.cost);
            let totalIncome = _.sumBy(this.dre,(item) => item.income);
            let total = {_id:{id:'0',name:'TOTAL'},cost: totalCost,income: totalIncome};
            this.dre.push(total);

            this.json2csvService.export(
                this.dre.map(approval => {
                    return {
                        // Customer: approval.customer? approval.customer: "-" ,
                        Project: approval._id.name? approval._id.name : "-",
                        Cost: approval.cost ? approval.cost.toLocaleString("pt-BR",{maximumFractionDigits : 3}) : 0,
                        Income: approval.income ? approval.income.toLocaleString("pt-BR",{maximumFractionDigits : 3}) : 0,
                        'Margin(%)': (approval.cost && approval.income) ? (((approval.income/approval.cost)-1)*100).toLocaleString("pt-BR",{maximumFractionDigits : 3}) : 0
                    };
                }),
                `DRE - ${new Date().toLocaleDateString('pt-br')}`
            );
        }else{
            let consultantsExport = [];

            consultantsExport = this.cost.map(approval => {
                    let format = this.setFormat(approval);
                    return format
            })

            this.json2csvService.export(consultantsExport,
                `relatório de custo por projeto - ${new Date().toLocaleDateString('pt-br')}`
            );
        }

        this.loading = false;
    }

    setFormat(approval){
        return{
            'Consultor': approval.consultant.name ? approval.consultant.name.trim() : "-",
            'Competência': approval.date ? this.getCompetence(approval.date) : "-",
            'Gestor': approval.projects.responsible ? approval.projects.responsible.name : "-",
            'Grupo_de_empresa': approval.projects.companyGroup ? approval.projects.companyGroup.name : "-" ,
            'Cliente': approval.projects.customer ? approval.projects.customer.financialName : "-",
            'Projeto': approval.projects ? approval.projects.name : "-",
            'Setor': approval.projects.customer.details.length > 0 && approval.projects.customer.details[0].industry ? approval.projects.customer.details[0].industry.name : '-',
            'Centro_de_Excelencia': approval.consultant && approval.consultant.excellenceCenter ? approval.consultant.excellenceCenter.name : '-',
            'Area_de_Suporte': approval.consultant && approval.consultant.supportCenter ? approval.consultant.supportCenter.name : '-',
            'Valor_hora': approval.consultant.contract.hourValue ? approval.consultant.contract.hourValue.toLocaleString("pt-BR",{maximumFractionDigits : 3}) : "-",
            'Horas_aprovadas': approval.projects.total_hours ? approval.projects.total_hours.toLocaleString("pt-BR",{maximumFractionDigits : 3}) : "-",
            'Valor': approval.totalValue ? approval.totalValue.toLocaleString("pt-BR",{maximumFractionDigits : 3}) : "-",
            'Tipo_de_aprovação': approval.approvalExpense ? 'Despesa':'Custo' ,
            'Tipo_de_contrato': approval.consultant.contract ? this.commonHelper.transcriptContractType(approval.consultant.contract.kind) : '-' ,
            'ID APROVAÇÃO': approval._id ? approval._id.trim() : "-",
            'Carta_de_Faturamento': approval.billingLetter ? approval.billingLetter.name : "-",
            'Competência_carta': approval.billingLetter ? approval.billingLetter.parcels.competence+'/'+approval.billingLetter.parcels.competenceYear : "-",
            'Valor_da_parcel': approval.billingLetter ? approval.billingLetter.parcels.project.value : "-"
        }
    }

    verifyApprovalDate(approval) {
        // Alterar a data da variável "limitDate", para o dia "2022-01-03" quando for para Produção.
        let limitDate = new Date("2021-12-01").getTime();
        let approvalDate = new Date(approval.created).getTime();
        if(approvalDate > limitDate){
            return false;
        }
        return true;
    }

    generateDre(){
        let projects = _.uniqBy(this.cost,'projects.name');
    }

    verifyDate(date,field){
        if(!(new RegExp(this.datePattern).test(date))){
            this.toastr.warning(`Digite uma data válida.`,"Data inválida!");
            this.filters[`${field}`] = null;
        }
    }

    saveFilters() {
        this.localStorage.save(this.loadFilters(), 'cost');
    }

    getCompetence(dateApproval){
        //return moment(dateApproval).utc().format("MM/YYYY")
        const date = moment(dateApproval)
        const mouth = this.commonHelper.formatMonth(date.month())
        const year = date.year();
        return `${mouth}/${year}`;
    }
}



// WEBPACK FOOTER //
// ./src/app/views/reports/cost-by-project-report/cost-by-project-report.component.ts